// General
import { gsap, Power4 } from 'gsap'

import { ready } from './lib/ready'
import { Breakpoints } from './lib/breakpoints';

// Stimulus.js and controllers
import { Application } from 'stimulus';
import ExpandableController from './lib/expandable';
import NavMainSubMenuController from './lib/nav-main-sub-menu-controller';
import HeaderController from './lib/header-controller';
import SearchFieldController from './lib/search-field-controller';
import DisruptorController from './lib/disruptor-controller';
import TabbedHighlightsController from './lib/tabbed-highlights-controller';
import KeyvisualController from './lib/keyvisual-controller';
import FilterController from './lib/filter-controller';
import PopupController from './lib/popup-controller';

// Setup functions
import { InView } from './lib/in-view';
import { AnchorScrollTo } from './lib/anchor-scroll-to';
import { SetupSwiper } from './lib/setup-swiper';
import { Lightbox } from './lib/Lightbox';
import { NavTop } from './lib/nav-top';
import { StyledCheckboxes } from './lib/styled-checkboxes';
import { bodyScrollClass } from './lib/body-scroll-class';

let fsNeedsUpdate = true
let currentVw = window.innerWidth

const update100vh = () => {
  if (currentVw !== window.innerWidth) {
    fsNeedsUpdate = true
    currentVw = window.innerWidth
  }

  if (fsNeedsUpdate) {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    fsNeedsUpdate = false
  }

}

window.addEventListener('resize', update100vh)

update100vh()

gsap.defaults({
  ease: Power4.easeInOut,
  duration: 0.35
});

ready(function () {

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (isIE11) document.body.classList.add("-is-ie-11");

  const isLandingpage = document.body.classList.contains("page-template-template-landingpage");
  // Stimulus.js and controllers
  const application = Application.start();
  application.register('expandable', ExpandableController);
  if (!isLandingpage) {
    application.register('nav-main-sub-menu', NavMainSubMenuController);
    application.register('header', HeaderController);
    application.register('search-field', SearchFieldController);
    new NavTop();
  }
  application.register('disruptor', DisruptorController);
  application.register('tabbed-highlights', TabbedHighlightsController);
  application.register('keyvisual', KeyvisualController);
  application.register('filter', FilterController);
  application.register('popup', PopupController);

  // Setup functions
  InView();
  AnchorScrollTo();
  SetupSwiper();
  Lightbox();
  StyledCheckboxes();
  bodyScrollClass();

});